export default __webpack_public_path__ + "static/media/apple-pay-white.2c301ee6.svg";